const getScaleAnswers = scaleDescription => {
  const answers = [];

  if (scaleDescription) {
    const { minValue, maxValue } = scaleDescription;
    for (let value = minValue; value <= maxValue; value += 1) {
      answers.push(value);
    }
  }

  return answers;
};

export default getScaleAnswers;



// WEBPACK FOOTER //
// ./src/utils/getScaleAnswers.js